export default __webpack_public_path__ + "static/media/inr_green.6a4ecbf4.svg";